import { type StartCommunityOfPractice } from '../models/StartCommunityOfPractice'
import { useEffect, useState } from 'react'
import { type UpdateStartCommunityOfPracticeFormValues } from '../pages/pageComponents/planning/priorityActivities/PriorityOne/StartCommunityOfPracticeModal'
import { GetStartCommunityOfPractices, LockActivity, UnlockActivity } from '../services/AnnualPlanService'
import { StartCommunityOfPracticeType } from '../models/StartCommunityOfPracticeType'
interface UseStartCommunityOfPracticesType {
  startCommunityOfPractices: StartCommunityOfPractice[]
  isLoading: boolean
  reloadCommunityOfPractices: () => Promise<void>
}

export const useStartCommunityOfPractices = (priorityId: number, implementationPhase: boolean): UseStartCommunityOfPracticesType => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [startCommunityOfPractices, setStartCommunityOfPractices] = useState<StartCommunityOfPractice[]>([])

  const loadCommunityOfPractices = async (): Promise<void> => {
    setIsLoading(true)

    const communityOfPractices = await GetStartCommunityOfPractices(priorityId, implementationPhase)
    setStartCommunityOfPractices(communityOfPractices)

    setIsLoading(false)
  }

  useEffect(() => {
    void loadCommunityOfPractices()
  }, [])

  return { startCommunityOfPractices, isLoading, reloadCommunityOfPractices: loadCommunityOfPractices }
}

interface UseStartCommunityOfPracticeModalType {
  handleAddCommunityOfPractice: () => void
  handleEditCommunityOfPractice: (startCommunityOfPractices: Record<StartCommunityOfPracticeType, UpdateStartCommunityOfPracticeFormValues>) => Promise<void>
  handleCloseModal: () => Promise<void>
  showCommunityOfPracticeModal: boolean
  initialValues?: Record<StartCommunityOfPracticeType, UpdateStartCommunityOfPracticeFormValues>
}

export const useStartCommunityOfPracticeModal = (): UseStartCommunityOfPracticeModalType => {
  const [initialValues, setInitialValues] = useState<Record<StartCommunityOfPracticeType, UpdateStartCommunityOfPracticeFormValues>>()
  const [showCommunityOfPracticeModal, setShowCommunityOfPracticeModal] = useState(false)

  const handleAddCommunityOfPractice = (): void => {
    setInitialValues(undefined)
    setShowCommunityOfPracticeModal(true)
  }

  const handleEditCommunityOfPractice = async (startCommunityOfPractices: Record<StartCommunityOfPracticeType, UpdateStartCommunityOfPracticeFormValues>): Promise<void> => {
    setInitialValues({ ...startCommunityOfPractices })
    setShowCommunityOfPracticeModal(true)
    // Use the id of the first community of practice to lock the activity
    await LockActivity(startCommunityOfPractices[StartCommunityOfPracticeType.Coaching].id, 'START Community Of Practice')
  }

  const handleCloseModal = async (): Promise<void> => {
    setShowCommunityOfPracticeModal(false)
    if (initialValues != null) {
      await UnlockActivity(initialValues[StartCommunityOfPracticeType.Coaching].id, 'START Community Of Practice')
    }
  }

  return {
    handleAddCommunityOfPractice,
    handleEditCommunityOfPractice,
    handleCloseModal,
    showCommunityOfPracticeModal,
    initialValues
  }
}
